import { SearchTransferModel } from 'ts/transfer/classes/SearchTransferModel';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nSharedConfig } from 'utils/shared/utils';
import { i18nConfig as i18nUiConfig } from 'utils/ui';
import { enUS, he } from 'date-fns/locale';
import { format } from 'date-fns';

export const dateFormat = (
  date: Date | string | undefined | number,
  formatStr: string,
  locale?: string
) => {
  const lang = locale || localStorage.getItem('language');
  const dateObj = date == null ? new Date() : date instanceof Date ? date : new Date(date);

  return format(dateObj, formatStr, { locale: lang === 'en' ? enUS : he });
};
export const getSearchParams = (model: SearchTransferModel) => {
  const params = new URLSearchParams();
  params.append('people', model.people.toString());
  params.append('countryCodeFrom', model.countryCodeFrom);
  params.append('countryCodeTo', model.countryCodeTo);
  params.append('departureDate', dateFormat(model.departureDate, "yyyy-MM-dd'T'HH:mm", 'en'));
  params.append('returnDate', dateFormat(model.returnDate, "yyyy-MM-dd'T'HH:mm", 'en'));
  params.append('pickup.code', model.pickup.code);
  params.append('pickup.desc', model.pickup.desc);
  params.append('pickup.latitude', model.pickup.latitude);
  params.append('pickup.longitude', model.pickup.longitude);
  params.append('pickup.type', model.pickup.type.toString());
  params.append('dropoff.code', model.dropoff.code);
  params.append('dropoff.desc', model.dropoff.desc);
  params.append('dropoff.latitude', model.dropoff.latitude);
  params.append('dropoff.longitude', model.dropoff.longitude);
  params.append('dropoff.type', model.dropoff.type.toString());
  params.append('searchType', model.searchType);
  return params.toString();
};

export interface i18nTransferConfigProps {
  enTranslation: any;
  heTranslation: any;
  esTranslation: any;
}

export const i18nTransferConfig = (props: i18nTransferConfigProps) => {
  const lang = localStorage.getItem('language');

  i18nSharedConfig({ ...props, ruTranslation: {} });
  i18nUiConfig(props);

  i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: props.enTranslation,
      },
      he: {
        translation: props.heTranslation,
      },
      es: {
        translation: props.esTranslation,
      },
    },
    lng: lang ? lang : 'he',
    fallbackLng: 'he',

    interpolation: {
      escapeValue: false,
    },
  });
};

export default i18n;
